module.exports = __webpack_public_path__ + "img/filter-tester.d9809a2c.png";